<div class="forgot-password">

  <h2 class="ui header center aligned light">Forgot Password</h2>


  <div *ngIf="error" class="ui negative message">
    {{error}}
  </div>


  <div class="ui form" *ngIf="!resetRequestSent">

    <div class="field required">
      <label>Email</label>
      <div class="ui left icon input">
        <i class="user icon"></i>
        <input type="text" name="email" placeholder="E-mail address" [(ngModel)]="email"
          [disabled]="requestInProgress" />
      </div>
      <div class="ui pointing left red basic label" *ngIf="submitted && email == null">
        Please enter your email.
      </div>
    </div>

    <div class="button-desc">
      We will send you instructions to reset your password to the email address above.
    </div>

    <button class="ui fluid large primary button" (click)="resetPassword()"
      [ngClass]="{'disabled': requestInProgress, 'loading' : requestInProgress}">Request Password Reset</button>



  </div>



  <div *ngIf="resetRequestSent" class="request-sent">
    We have sent you email with instructions to reset your password.
  </div>

</div>